

import { authHeader } from '../helpers/authHeader';
import apiClient from '../helpers/apiClient';



export const corporateService = {
    getCorporateList,
    getCorporateListNoCache,
    getCorporateDetails,
    createCorporation,
    getCorporateListSearch,
    getCustomerApprovedList,
    getCustomerApproveDetails,
    approveOrCancelCustomerRequest,
    uploadFile,
    getCorporateApprovedList,
    approveOrCancelCorporateRequest,
    toggleAdminStatus
};


function getCorporateList(start= 0,end=50){
  return apiClient.get(`/subscriptions/get-corporation-list?start=${start}&end=${end}`, authHeader());
} 


function uploadFile(fileData){
  return apiClient.post(`/external-grocedy/upload-files`, fileData);
} 

function getCorporateListSearch(search,start= 0,end=50){
  return apiClient.get(`/subscriptions/get-corporation-list-search?start=${start}&end=${end}&search=${search}`, authHeader());
} 


function getCorporateListNoCache(start= 0,end=50){
  return apiClient.get(`/subscriptions/get-corporation-list-no-cache?start=${start}&end=${end}`, authHeader());
} 

function getCorporateDetails(id){
  return apiClient.get(`/subscriptions/get-corporation-details/${id}`, authHeader());
}

function toggleAdminStatus(statusId, customer_id){
  return apiClient.get(`/subscriptions/toggle-admin-status/${statusId}/${customer_id}`, authHeader());
}

function createCorporation(data){
  return apiClient.post(`/subscriptions/create-corporation`,data, authHeader());
}


function getCustomerApprovedList(start= 0,end=50){
  return apiClient.get(`/subscriptions/get-customer-app-list?start=${start}&end=${end}`, authHeader());
} 

function getCorporateApprovedList(){
  return apiClient.get(`/subscriptions/get-corporate-approval-list`, authHeader());
} 



function getCustomerApproveDetails(id){
  return apiClient.get(`/subscriptions/get-customer-approve-details/${id}`, authHeader());
}

function approveOrCancelCustomerRequest(id,option, remark){
  return apiClient.get(`/subscriptions/approve-or-cancel-request/${id}/${option}/${remark}`, authHeader());
}

function approveOrCancelCorporateRequest(id,option, remark){
  return apiClient.get(`/subscriptions/approve-or-cancel-corporate-request/${id}/${option}/${remark}`, authHeader());
}









